import { FocusEventHandler, forwardRef, ForwardedRef } from "react";
import { Input } from "antd";
import { ValidationError } from "../validation-error";
import "./input.scss";

interface IFormInputProps {
  onChange: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  label?: string;
  name?: string;
  error?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  value?: string;
}

export const FormInput = forwardRef(
  (
    {
      value,
      error = "",
      name,
      label,
      placeholder,
      disabled = false,
      onBlur,
      onChange,
      className = "",
    }: IFormInputProps,
    ref: ForwardedRef<any>,
  ): JSX.Element => {
    return (
      <div className="field-input">
        {label && <label className="field-input__label">{label}</label>}
        <Input
          className={`${className} form-input`}
          ref={ref}
          name={name}
          status={error ? "error" : undefined}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          value={value}
        />
        {error && <ValidationError>{error}</ValidationError>}
      </div>
    );
  },
);

export default FormInput;
